import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'

import { loadSyncDetails } from './load.js'
import { showDetails } from './show-details/show-details.js'
import { showDetailGrid } from './details-tables/show-detail-grid.js'
import { makeColumnDefsModules } from './details-tables/column-defs-modules.js'
import { makeColumnDefsErrors } from './details-tables/column-defs-errors.js'
import { makeColumnDefsSteps } from './details-tables/column-defs-steps.js'
import showSyncActions from './show-sync-actions.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 * @param {String} params.dataSyncId
 *
 * @returns
 */
export async function showAdminSyncDetails (params) {
  console.log('showAdminSyncDetails')

  const { containerElementId, browserAppUser, dataSyncId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  // Set page title
  document.title = ['Data Syncs'].join(' ')

  const dataSyncApiResponse = await loadSyncDetails(dataSyncId)

  showSyncActions({
    containerElementId: 'syncActions',
    dataSyncApiResponse
  })

  showDetails({
    containerElementId: 'syncOverall',
    dataSyncApiResponse
  })

  showDetailGrid({
    containerElementId: 'syncModules',
    emptyMessage: 'No modules synced',
    rows: dataSyncApiResponse.data_sync_modules,
    columnDefs: makeColumnDefsModules()
  })

  showDetailGrid({
    containerElementId: 'syncErrors',
    emptyMessage: 'No errors',
    rows: dataSyncApiResponse.data_sync_errors,
    columnDefs: makeColumnDefsErrors()
  })

  showDetailGrid({
    containerElementId: 'syncSteps',
    emptyMessage: 'No steps',
    rows: dataSyncApiResponse.data_sync_steps,
    includeFilterRow: true,
    maxRows: 20,
    columnDefs: makeColumnDefsSteps()
  })
}
